import styled from '@emotion/styled'
import { Box } from '..'

export const Container = styled(Box)({
  position: 'relative',
  width: '100%',
  height: '100%',
  paddingBottom: '20px',
})
